<template>
    <div>
        <p v-if="requestOnTaskList.length === 0"><em>Der er ikke nogen tilknyttede henvendelser</em></p>

        <div v-for="enquiry in requestOnTaskList" v-if="requestOnTaskList && requestOnTaskList.length > 0" :key="enquiry.requestId">
            <div class="grid-x list-row supply align-items sidebar-color" :class="businessAreaClass(enquiry.businessAreaTypeId)">
                <div class="cell large-1">
                    <icon class="enquiry-svg medium-svg fill-primary" name="enquiry" />
                </div>
                <div class="cell large-4 item truncate-fade">
                    <span v-if="enquiry.address1">{{ enquiry.address1 }}, <span v-if="enquiry.address2">{{ enquiry.address2 }},</span> {{ enquiry.postalCode }} {{ enquiry.city }}</span>
                    <span v-else>Ingen adresse</span>
                    <span v-if="!enquiry.clientAnonymous && enquiry.clientName">{{ enquiry.clientName }}</span>
                    <span v-else>Anonym</span>
                </div>
                <div class="cell large-3 item truncate-fade">
                    <span v-if="enquiry.problemType">{{ enquiry.problemType }}</span>
                    <span v-else>Ingen problemtype</span>
                    <span v-if="enquiry.description">{{ enquiry.description }}</span>
                    <span v-else>Ingen beskrivelse</span>
                </div>
                <div class="cell large-2 item">
                    <span>{{ enquiry.occurrenceDateTime | formatDateShortElapsed }}</span>
                    <span>{{ enquiry.occurrenceDateTime | formatTime }}</span>
                </div>
                <div class="cell large-2 item flexbox-center">
                    <div class="enquiry-status" v-if="enquiry.requestStatus">{{ enquiry.requestStatus}}</div>
                    <div class="enquiry-status" v-else>Registreret</div>
                </div>
                <router-link class="dashboard-list-link" :to="{ name: 'enquiryid', params: { id: enquiry.requestId } }">
                    <span class="visually-hidden">Åben henvendelse</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'task-accordion-enquiries',
    computed: {
        ...mapGetters({
            requestOnTaskList: 'getTaskRequest',
            supplyTypes: 'getSysBusinessAreaTypeList'
        })
    },
    methods: {
        businessAreaClass (businessAreaType) {
            return this.supplyTypes.find(supplyType => supplyType.sysBusinessAreaTypeId === businessAreaType).systemName
        }
    }
}
</script>

<style lang="scss">
.margin-bottom {
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/task/task-accordion-enquiries.vue